import { makeStyles, createStyles } from '@material-ui/core';

export const useStyles = makeStyles(() =>
  createStyles({
    addButtonContainer: {
      width: '100%',
      marginBottom: 15,
    },
    addButton: {
      width: 150,
      backgroundColor: 'white',
    },
    accordionContainer: {
      backgroundColor: '#eaeaea',
    },
  }),
);

export const formStyles = makeStyles(() =>
  createStyles({
    inputContainer: {
      display: 'flex',
      flexDirection: 'column',
      width: '100%',
    },
    label: {
      marginTop: 5,
      fontFamily: 'Roboto',
      fontSize: 14,
      alignSelf: 'start',
      color: '#000000',
    },
    input: {
      marginTop: 10,
      height: 40,
      width: '100%',
      border: '1px solid #ccc',
      backgroundColor: 'white',
      overflow: 'hidden',
      borderRadius: 4,
      padding: 10.5,
      boxSizing: 'border-box',
      '&:hover': {
        borderColor: 'black',
      },
      '&:focus': {
        border: '1.5px solid #3f51b5',
      },
    },
    errorInput: {
      border: '1px solid red',
      '&:hover': {
        borderColor: 'red',
      },
      '&:focus': {
        border: '1.5px solid red',
      },
    },
    select: {
      marginTop: 10,
      height: 40,
      width: '100%',
      backgroundColor: 'white',
      '& div': {
        '&:focus': {
          backgroundColor: 'transparent',
        },
      },
    },
    accordionRow: {
      display: 'flex',
      alignItems: 'start',
    },
  }),
);
